import React, { useEffect } from 'react';
import { usePopup } from './PopupContext';
import { Link } from 'react-router-dom';
import CourseLogoSlider from './CourseLogoSlider';

const Homesection = () => {
   const { setShowPopup } = usePopup();

   const handleEnquiryClick = (e) => {
    e.preventDefault();
    setShowPopup(true);
  };

  const logos1 = [
        '/assets/images/courselogo/android.webp',
        '/assets/images/courselogo/Angular.webp',
        '/assets/images/courselogo/aws.webp',
        '/assets/images/courselogo/cs.webp',
        '/assets/images/courselogo/da.webp',
  ];

  useEffect(() => {
    const carouselEl = document.querySelector('#homeCarousel');
    if (carouselEl) {
      const carousel = new window.bootstrap.Carousel(carouselEl, {
        interval: 4000,
        ride: 'carousel',
        pause: false,
      });
    }
    }, []);

  return (
    <div className='bgcolor4 text-white'>
      <section aria-labelledby="main-heading" className="container py-4">
        <h1 id="main-heading" className="fw-bolder">100% Skills = 100% Job</h1>
        <p className="fw-bold">
          India`s Most Trusted Online & Offline IT Training Institute
        </p>
        <CourseLogoSlider />
        <br />
        <div>
          <button
            className="btn me-md-2 brcolor_and_txcolor2 fw-bold mb-2"
            type="button"
            onClick={handleEnquiryClick}
            aria-label="Open enquiry form"
          >
            Enquire Now
          </button>
          &nbsp;
          <Link
            className="btn brcolor_and_txcolor2 fw-bold mb-2"
            to="/batchschedule"
            aria-label="Go to batch schedule"
          >
            Click For Free Demo Session
          </Link>
        </div>
      </section>
    </div>

  );
};

export default Homesection;
